<div class="modal-content anpp">
  <div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel"><fa-icon icon="leaf"></fa-icon> <b translate> page.inventaire-verger.modals.cultureBio.cultureBioTitle</b></h5>
    <div class="pointer ms-auto" data-dismiss="modal" aria-label="Close">
      <fa-icon icon="times" (click)="cancel()" (keydown.enter)="cancel()"></fa-icon>
    </div>
  </div>
  <div class="modal-body">
    <form [formGroup]="formGroup" #form="ngForm" (ngSubmit)="submit()" novalidate>
      <div class="mb-3">
        <ng-container *ngFor="let culture of refCultureBios">
          <div class="row">
            <div class="col-lg-12 sub-popup-title">
          <input [ngClass]="{'is-invalid': form.submitted && cultureBio.invalid }" type="radio" class="me-2 style-radio-buttton" id="{{'cultureBio'+culture.id}}" formControlName="cultureBio" value="{{ culture.id }}" />
          <label for="{{'cultureBio'+culture.id}}" class="me-5" translate>{{ culture.libelle }}</label>
          </div>
          </div>
        </ng-container>
      </div>

      <div class="modal-footer">
        <button type="submit" class="btn btn-primary" style="background:#41905c;border:1px solid #41905c"
                data-dismiss="modal" aria-label="Close"translate>page.inventaire-verger.buttonEnregistrer
        </button>
      </div>
    </form>
  </div>
</div>

